import React, { PureComponent } from "react";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import KBELogo from "../account/img/kbe-Logo-66454.png";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import VerticalSpace from "./components/VerticalSpace";
import AppConfig from "../../config/appconfig.json";

export default class ServiceRecords extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            systemId: this.props.location.state
                ? this.props.location.state.systemId
                : null,
            svcRecordList: [],
            system: this.props.location.state ? this.props.location.state.system : null,
            isNoServiceRecord: false,
            errorMsg: "",
            isSvcReportError: false,
            serviceReportErrorMsg: ""
        };
    }

    componentDidMount() {
        if (this.state.systemId) {
            let isRetrieveServiceRecordFailed = false;
            // Call Back-End Services
            fetch(
                `${AppConfig.BACK_END_URL}/APIClient/RetrieveServiceRecord?systemSid=` +
                this.state.systemId
            )
                .then(response => {
                    // console.log(response);
                    if (response.ok === false) {
                        isRetrieveServiceRecordFailed = true;
                    }
                    return response.json();
                })
                .then(json => {
                    if (isRetrieveServiceRecordFailed) {
                        const respObj = JSON.parse(json);
                        // console.log(respObj.Message);
                        const svcRcrd = localStorage.getItem("SvcRcrd_" + this.state.systemId);
                        if (svcRcrd) {
                            const svcRcrdObj = JSON.parse(svcRcrd);
                            this.setState({ svcRecordList: svcRcrdObj });
                        }
                        else {
                            this.setState({ isNoServiceRecord: true, errorMsg: respObj.Message });
                        }

                    } else {
                        const respObj = JSON.parse(json);
                        // console.log(respObj);
                        this.setState({
                            svcRecordList: respObj
                        });
                        localStorage.setItem("SvcRcrd_" + this.state.systemId, JSON.stringify(respObj));
                        // this.setState({
                        //     svcRecordList: [{
                        //         "ReportSid": "201810053iXSHCPjzdFg",
                        //         "AppointmentDate": "03-Okt-2018",
                        //         "JobPerformed": "Chemical Wash - Wall mounted (18K-24K Btu) FCU: 2 Units, Hydrokleen - Cassette Unit FCU: 3 Units",
                        //         "InvoiceAmount": "208,65"
                        //     }]
                        // });
                    }
                })
                .catch(() => {
                    console.log(
                        "Something went wrong when retrieving service records. Please try again."
                    );
                    const svcRcrd = localStorage.getItem("SvcRcrd_" + this.state.systemId);
                    if (svcRcrd) {
                        const respObj = JSON.parse(svcRcrd);
                        this.setState({ svcRecordList: respObj });
                    }
                });
        }
    }

    render() {
        return (<div>
            <div className="account">
                <div className="account__wrapper">
                    <div className="account__card">
                        <div className="account__head">
                            <img src={KBELogo} alt="logo" />
                        </div>
                        <div className="account__main" style={{ minWidth: "350px" }}>
                            <div>Service Record for {this.state.system.Brand + " " + this.state.system.Type + " " + this.state.system.Model}</div>
                            {this.state.isSvcReportError ? (<span className="list-text-red">{this.state.serviceReportErrorMsg}</span>) : (<span></span>)}
                            <List component="nav">
                                <Divider />
                                {this.state.isNoServiceRecord ? (
                                    <div>
                                        <ListItem button>
                                            <Grid container spacing={0}>
                                                <Grid item xs={12}>
                                                    <ListItemText>
                                                        <div className="list-text">{this.state.errorMsg}</div>
                                                    </ListItemText>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        <Divider />
                                    </div>
                                ) : (<span></span>)}
                                {this.state.svcRecordList.map(svcRecord =>
                                    <div key={svcRecord.ReportSid}>
                                        <ListItem button>
                                            <Grid container spacing={0}>
                                                <Grid item xs={10}>
                                                    <ListItemText>
                                                        <div className="list-text">Appointment Date: {svcRecord.AppointmentDate}</div>
                                                        <div className="list-text">Job Performed: {svcRecord.JobPerformed}</div>
                                                        <div className="list-text">Invoice Amount: {svcRecord.InvoiceAmount}</div>
                                                    </ListItemText>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <ListItemText>
                                                        <div className="list-text">
                                                            {/* <a target="_blank"
                                                                href={`${AppConfig.BACK_END_URL}/APIClient/GetServiceReport?reportSid=` + svcRecord.ReportSid}>
                                                                View Service Report
                                                                </a> */}
                                                            <a onClick={() => {
                                                                // console.log('click');
                                                                this.setState({ isSvcReportError: false });
                                                                // Call Back-End Services
                                                                let isGetServiceReportFailed = false;
                                                                fetch(
                                                                    `${AppConfig.BACK_END_URL}/APIClient/GetServiceReport?reportSid=` +
                                                                    svcRecord.ReportSid
                                                                    // , {
                                                                    //     method: 'GET',
                                                                    //     responseType: 'blob' //Force to receive data in a Blob Format
                                                                    // }
                                                                )
                                                                    .then(response => {
                                                                        // console.log(response);
                                                                        if (response.ok === false) {
                                                                            isGetServiceReportFailed = true;
                                                                            // const respObj = JSON.parse(json);
                                                                            // console.log(respObj);
                                                                            return response.json();
                                                                        }
                                                                        else {

                                                                            setTimeout(() => {
                                                                                const download = {
                                                                                    file: response.url,
                                                                                };
                                                                                // server sent the url to the file!
                                                                                // now, let's download:
                                                                                window.open(download.file);
                                                                                // you could also do:
                                                                                // window.location.href = response.file;
                                                                            }, 100);
                                                                            return null;
                                                                        }
                                                                    })
                                                                    .then(json => {
                                                                        if (isGetServiceReportFailed) {
                                                                            const respObj = JSON.parse(json);
                                                                            // console.log(respObj);
                                                                            this.setState({ isSvcReportError: true, serviceReportErrorMsg: respObj.Message });
                                                                        }
                                                                    })
                                                                    .catch(() => {
                                                                        console.log(
                                                                            "Something went wrong when getting service report. Please try again."
                                                                        );
                                                                    });
                                                            }}>
                                                                View Service Report
                                                                </a>
                                                        </div>
                                                    </ListItemText>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        <Divider />
                                    </div>
                                )}
                            </List>
                            <VerticalSpace />
                        </div>
                        <SimpleBottomNavigation value={2} />
                    </div>
                </div>
            </div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/pages/main/ServiceRecords.js